import { useContext } from 'react';
import { ContextUserProfile } from '../contexts/UserProfileContext';
import { ThemeTypes } from '../types/theme/themeTypes';
import { setLSTheme } from '../utils/userProfileContextHelpers';
import { getThemeVariable } from '../stylesheets/cssVariablesUtils';

const useTheme = () => {
    const { theme, setTheme } = useContext(ContextUserProfile);

    const handleTheme = (newTheme: ThemeTypes) => {
        setTheme(newTheme);
        setLSTheme(newTheme);
    };

    //  color name should be in camelCase, e.g. primaryMain, grey200, errorLight...
    //  it will return the corresponding color from theme.module.scss depending on the current theme (light or dark)
    //  ex => background => lightBackground or darkBackground
    //  ex => grey200 => lightGrey200 or darkGrey200
    const getThemeColor = (colorName: string) => {
        const themeColorKey = `${theme}${colorName
            .charAt(0)
            .toUpperCase()}${colorName.slice(1)}`;
        return getThemeVariable(themeColorKey);
    };

    return { theme, setTheme: handleTheme, getThemeColor };
};

export default useTheme;
